import request from '#/utils/request';
import { keysToSnake } from '#/api/adapters/wireCase';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

export async function createStockReceipt(payload) {
  const { data: raw } = await request.post('/ims/stock-receipt', keysToSnake(payload));
  return parseVer4DetailResponse(raw);
}
